import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const DepositDetailsPage = lazy(() => import('./DepositDetailsPage'));

const DepositDetailsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Payments,
  routes: [
    {
      path: 'payors/:payorId/deposits/:id',
      element: <DepositDetailsPage />,
    },
  ],
};

export default DepositDetailsConfig;
